import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/unlink-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-7b017624"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "unlink-section" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"unlink-content-container\" data-v-7b017624><div class=\"unlink-icon\" data-v-7b017624><img src=\"" + _imports_0 + "\" data-v-7b017624></div><div class=\"unlink-title\" data-v-7b017624><div data-v-7b017624><span data-v-7b017624>ยกเลิกการเชื่อมต่อ</span></div><div data-v-7b017624><span data-v-7b017624>บัญชี LINE แล้ว</span></div></div><div class=\"unlink-description\" data-v-7b017624><span data-v-7b017624>คุณสามารถเชื่อมต่อบัญชีเพื่อเปิดระบบอีกครั้งที่หน้า Lotus’s Line Official Account</span></div></div>", 1)
const _hoisted_3 = { class: "unlink-button" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = $event => (_ctx.backToLine()))
      }, "กลับสู่หน้า LINE")
    ])
  ]))
}